export const reports = {
      title: 'Reportes',
      subtitle: 'Consulta reportes operativos de inventario',
      common: 'Reportes comunes',
      commonDescription: 'Reportes clave para una operación de fabricación y distribución.',
      view: 'Ver reporte',
      comingSoon: 'Próximamente',
      run: 'Generar reporte',
      kardexTitle: 'Kardex de producto',
      kardexDescription: 'Historial cronológico de entradas, salidas y saldo por SKU.',
      kardexWorkspaceTitle: 'Analizador de Kardex',
      kardexWorkspaceDescription: 'Selecciona un producto y, si lo necesitas, acota por almacén y rango de fechas.',
      backToReports: 'Volver a reportes',
      filtersTitle: 'Filtros del reporte',
      filtersDescription: 'Define la categoría, producto, almacén y período a consultar.',
      kardexResultTitle: 'Resultado del Kardex',
      kardexResultDescription: 'Consulta el detalle cronológico del producto seleccionado.',
      exportCsv: 'Exportar CSV',
      exportPdf: 'Exportar PDF',
      kardexEmptyTitle: 'Sin movimientos para el Kardex',
      kardexEmptyDescription: 'Selecciona un producto y genera el reporte para revisar sus movimientos.',
      selectProductPlaceholder: 'Selecciona un producto',
      allWarehouses: 'Todos los almacenes',
      allDates: 'Todo el historial',
      today: 'Hoy',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      openingBalance: 'Saldo inicial',
      closingBalance: 'Saldo final',
      totalInbound: 'Entradas',
      totalOutbound: 'Salidas',
      totalInboundValue: 'Valor de entradas',
      totalOutboundValue: 'Valor de salidas',
      netMovement: 'Movimiento neto',
      previousShort: 'Anterior',
      finalShort: 'Final',
      balanceBefore: 'Saldo anterior',
      balanceAfter: 'Saldo final',
      valuationTitle: 'Valuación de inventario',
      valuationDescription: 'Valor total del inventario con base en las existencias disponibles y su costo promedio.',
      valuationWorkspaceDescription: 'Consulta el valor actual del inventario por producto y almacén.',
      valuationResultTitle: 'Resultado de la valuación',
      valuationResultDescription: 'Detalle actual del inventario valorizado según costo promedio.',
      allProducts: 'Todos los productos',
      totalInventoryValue: 'Valor total',
      totalStock: 'Existencias totales',
      totalQuantity: 'Cantidad total',
      totalProducts: 'Productos',
      valuationEmptyTitle: 'Sin registros para la valuación',
      valuationEmptyDescription: 'Ajusta los filtros y vuelve a generar el reporte para revisar existencias valorizadas.',
      warehouseTitle: 'Inventario por almacén',
      warehouseDescription: 'Resumen de existencias disponibles agrupadas por almacén.',
      warehouseWorkspaceDescription: 'Agrupa las existencias actuales y su valor por almacén.',
      warehouseResultTitle: 'Resultado por almacén',
      warehouseResultDescription: 'Consulta el resumen consolidado por almacén para los filtros aplicados.',
      warehouseCount: 'Almacenes',
      lowStockCount: 'Bajo',
      criticalStockCount: 'Crítico',
      warehouseEmptyTitle: 'Sin registros por almacén',
      warehouseEmptyDescription: 'Ajusta los filtros y vuelve a generar el reporte para revisar el consolidado.',
      lowStockTitle: 'Productos con existencias bajas',
      lowStockDescription: 'Productos por debajo de las existencias mínimas definidas.',
      lowStockWorkspaceDescription: 'Detecta productos críticos o bajos según el mínimo configurado.',
      lowStockResultTitle: 'Resultado de existencias bajas',
      lowStockResultDescription: 'Consulta los productos que requieren atención por almacén.',
      movementQuantity: 'Cantidad del movimiento',
      totalLowStockItems: 'Registros',
      lowStockEmptyTitle: 'Sin productos bajo mínimo',
      lowStockEmptyDescription: 'No se encontraron productos críticos o bajos con los filtros aplicados.',
      movementsByTypeTitle: 'Movimientos por tipo',
      movementsByTypeDescription: 'Resumen de movimientos agrupados por tipo y dirección en el período consultado.',
      movementsByTypeWorkspaceDescription: 'Consolida movimientos por tipo para revisar volumen y valor del período.',
      movementsByTypeResultTitle: 'Resultado por tipo',
      movementsByTypeResultDescription: 'Consulta el resumen agrupado por tipo de movimiento.',
      totalMovements: 'Movimientos',
      totalMovementGroups: 'Tipos',
      productionSalesTitle: 'Producción vs salidas por venta',
      productionSalesDescription: 'Compara la producción registrada contra las salidas por venta del período.',
      productionSalesWorkspaceDescription: 'Compara producción y salidas por venta dentro del período seleccionado.',
      productionSalesResultTitle: 'Resultado producción vs salidas',
      productionSalesResultDescription: 'Consulta el comparativo diario entre producción y salidas por venta.',
      transfersTitle: 'Transferencias entre almacenes',
      transfersDescription: 'Consulta los movimientos de transferencia entre almacenes origen y destino.',
      transfersWorkspaceDescription: 'Revisa transferencias registradas entre almacenes en el período.',
      transfersResultTitle: 'Resultado de transferencias',
      transfersResultDescription: 'Consulta el detalle de transferencias origen-destino.',
      warehousePairs: 'Pares',
      clientOutboundTitle: 'Salidas por cliente',
      clientOutboundDescription: 'Detalle de salidas asociadas a clientes para seguimiento operativo.',
      clientOutboundWorkspaceDescription: 'Resume salidas por cliente para seguimiento comercial y operativo.',
      clientOutboundResultTitle: 'Resultado por cliente',
      clientOutboundResultDescription: 'Consulta el consolidado de salidas agrupado por cliente.',
      totalClients: 'Clientes',
    } as const;
